import {
  saveCorporationCodeOnDB,
  searchFlight,
  getAllCorporationCodes,
} from "../../service/negotiatePrice/negotiatePriceService";
import { v4 as uuidv4 } from "uuid";
import { CorporationCode } from "../../types/types";

const searchRandomFlight = async (
  corporationCode: string,
  airlineCode: string
) => {
  const sessionId = uuidv4();

  const result = await searchFlight(sessionId, corporationCode, airlineCode);
  console.log(result);

  return result;
};

const saveCorporationCode = (corporationCode: string, airlineCode: string) => {
  return saveCorporationCodeOnDB(corporationCode, airlineCode);
};

const getAllCorporation: () => Promise<CorporationCode[]> = async () => {
  try {
    const response = await getAllCorporationCodes();
    console.log("Corporation", response);
    return response;
  } catch (error) {
    console.log("Negotiate Price Controller >> getAllCorporation", error);
  }
};

export { searchRandomFlight, saveCorporationCode, getAllCorporation };
